// appContext store
import { defineStore } from "pinia";
import { RoleEnum } from "@/core/enum";
import type { UserContext } from "./context";
import type { UserPermissions } from "@/models";

const defaultPermissions = (): UserPermissions => ({ page: {} }) as unknown as UserPermissions;

export const defaultUserContext = (): UserContext => ({
  id: "",
  email: "",
  role: RoleEnum.EMPLOYEE,
  resumeId: null,
  manager: {} as any,
  managedEmployees: [],
  permissions: defaultPermissions(),
  firstName: "",
  lastName: "",
});

const defaultState = () => ({
  context: {
    user: defaultUserContext(),
  },
});

export const useAppContextStore = defineStore("appContext", {
  state: defaultState,
  actions: {
    setUserContext(context: UserContext) {
      const plain = JSON.parse(JSON.stringify(context ?? {}));

      const base = defaultUserContext();

      this.context.user = {
        ...base,
        ...plain,
        permissions: {
          ...(base.permissions as any),
          ...(plain.permissions ?? {}),
          page: {
            ...((base.permissions as any)?.page ?? {}),
            ...((plain.permissions as any)?.page ?? {}),
          },
        } as any,
      };
    },

    resetAll() {
      this.$reset();
    },
  },
});
